export default __webpack_public_path__ + "static/media/12-burns.a351219a.png";